import { AUTH_REDIRECT_URI_STORAGE_KEY } from "@/constants";
import type { SigninRedirectArgs } from "oidc-client-ts";

export type SignInRedirect = (args?: SigninRedirectArgs) => Promise<void>;

export function buildAccountAuthorizeQueryParams(
  iamAccountId: string
): Record<string, string> {
  return {
    account_id: iamAccountId,
    send_account_id_in_claims: "true",
  };
}

export function getIamAccountIdFromUserToken(
  user: { profile?: object } | null | undefined
): string | undefined {
  const profile = user?.profile;
  if (profile === undefined || !("account_id" in profile)) {
    return undefined;
  }

  const accountId = profile.account_id;
  return typeof accountId === "string" ? accountId : undefined;
}

export function getTokenTid(
  user: { profile?: object } | null | undefined
): string | undefined {
  const profile = user?.profile;
  if (profile === undefined || (!("tid" in profile) && !("sub" in profile))) {
    return undefined;
  }

  const tid = "tid" in profile ? profile.tid : profile.sub;
  return typeof tid === "string" ? tid : undefined;
}

export async function signInWithAccountContext(
  signinRedirect: SignInRedirect,
  iamAccountId: string,
  redirectUrl?: string
): Promise<void> {
  const redirectPath =
    redirectUrl ??
    `${window.location.pathname}${window.location.search}${window.location.hash}`;

  sessionStorage.setItem(AUTH_REDIRECT_URI_STORAGE_KEY, redirectPath);

  await signinRedirect({
    extraQueryParams: buildAccountAuthorizeQueryParams(iamAccountId),
  });
}
